import {ChildNodesChunk} from "../chunks/types/ChildNodesChunk";
import {ChunkType} from "../chunks/types/ChunkType";
import {childNodesItemChunkToChildNodeProps} from "./childNodesItemChunkToChildNodeProps";
import {ChildNodesProps} from "./types/ChildNodesProps";
import {getChildNameFromChildNodesItemChunk} from "./utils/getChildNameFromChildNodesItemChunk";

export function childNodesChunkToChildNodesProps(
  childNodesChunk: ChildNodesChunk
): ChildNodesProps<any, any> {
  const result = {} as ChildNodesProps<any, any>;
  const {children = []} = childNodesChunk;
  for (const chunk of children) {
    if (chunk.type === ChunkType.ChildNodesItem) {
      const childName = getChildNameFromChildNodesItemChunk(chunk);
      const childNodeProps =
        childNodesItemChunkToChildNodeProps(chunk);
      if (childNodeProps) {
        result[childName] = childNodeProps;
      }
    }
  }
  return result;
}
